module.exports = __webpack_public_path__ + "img/icon-moveto.3dee2234.svg";